export default "__VITE_ASSET__D0bOsE9V__$_?component__"